import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, catchError, map, mergeMap, of, shareReplay } from 'rxjs';

import { DmbEnvironment } from '../../dmb-environment';

@Injectable({ providedIn: 'root' })
export class CommsAuthService {
  private http = inject(HttpClient);
  private env = inject(DmbEnvironment);

  private refreshTokenTrigger = new BehaviorSubject(true);

  token = this.refreshTokenTrigger.pipe(
    mergeMap(() =>
      this.http.get<string>(`${this.env.v5Path()}/dmbauth`, { withCredentials: true }).pipe(catchError(() => of(''))),
    ),
    shareReplay({ bufferSize: 1, refCount: true }),
  );

  authenticated = this.token.pipe(map((v) => !!v));

  public refreshToken() {
    this.refreshTokenTrigger.next(true);
  }
}
